import ForgotPassword from './ForgotPassword.js';

export default ForgotPassword;
